'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

import { getAjax } from '../utils/ajax';
import { BasketBlock } from './order/basket_block';
import { Products } from './order/products';
import { Basket } from './order/basket';

function OrderInit (options) {
    var opt = _.merge({ }, {
        basket: '.js-order-cart',
        defaults: {
            count: -1,
            total: -1,
            href: ''
        }
    }, options);

    let basketRadio = Backbone.Radio.channel('basket');

    class OrderState extends Backbone.Model {
        defaults() {
            return opt.defaults;
        }
        initialize() {
            let self = this;

            self.listenTo(basketRadio, 'add:to:basket', self.addToBasket);
            self.listenTo(basketRadio, 'remove:from:basket', self.removeFromBasket);

            self.listenTo(basketRadio, 'calculator:to:basket', self.addCalculatorToBasket);
            self.listenTo(basketRadio, 'order:submit', self.submitOrder);

            // Если заказ успешно оформлен сгенерируем кастомное событие для body
            self.listenTo(basketRadio, 'order:is:success', function(){ self._triggerBodyEvent('tg-order-sent'); });
        }
        // Обновление данных о корзине
        loadBasket() {
            let self = this;
            getAjax({
                _do: 'load',
                result : 'json'
            },  {
                url: '/oa/'
            })
            .then(function (response) {
                if(!_.isUndefined(response.data.count) && (!_.isUndefined(response.data.total)) && (response.data.href)){
                    self.set({'count': response.data.count,
                              'total': response.data.total,
                              'href': response.data.href });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
        submitOrder(send_data) {
            let self = this;

            let data = _.extend({
                _do: 'order_submit',
                result: 'json'
            }, send_data);

            getAjax(data,
                {
                    url: '/oa/'
                }
            )
            .then(function (response) {
                basketRadio.trigger('order:submited', response);
            })
            .catch(function (error) {
                console.log(error);
            });

        }
        addCalculatorToBasket(calculator_model){
            let self = this;

            let type = calculator_model.get('type');
            let input_params = calculator_model.get('input_params');
            let data = {};
            _.each(input_params, function(item){
                data[type +'_' + item.name] = calculator_model.get(type+'_'+item.name);
            });
            data['type'] = type;
            data['price_id'] = calculator_model.get('price_id');
            data['calculator_id'] = calculator_model.get('calculator_id');
            data['count'] = calculator_model.get('count');

            data['_do'] = 'calculator_add_item';
            data['result'] = 'json';

            getAjax(data,
                {
                    url: '/oa/'
                }
            )
            .then(function (response) {
                self._changeBasketState(response);

                if(!_.isUndefined(response.data.item)){
                    basketRadio.trigger('calculator:in:basket', { calculator_id: response.data.item.calculator_id,
                                                                  name: response.data.item.name,
                                                                  count: response.data.item.count });

                    // Если товар успешно добавлен в корзину из калькулятора, то вызовем кастомное событие
                    self._triggerBodyEvent('tg-product-add-from-calc');
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
        addToBasket(product_model) {
            let self = this;
            let data = { count:  product_model.get('count') };
            if(product_model.has('product_id')){
                data['id'] = product_model.get('product_id');
            }
            if(product_model.has('hash')){
                data['hash'] = product_model.get('hash');
            }
            self._changeCount(data);
        }
        removeFromBasket(product_model) {
            let self = this;
            let data = { count: 0 };
            if(product_model.has('product_id')){
                data['id'] = product_model.get('product_id');
            }
            if(product_model.has('hash')){
                data['hash'] = product_model.get('hash');
            }
            self._changeCount(data);
        }
        _triggerBodyEvent(event_name){
            if(event_name){
                $('body').trigger(event_name);
            }
        }
        _changeCount(product) {
            let self = this;
            let data = _.extend({ _do: 'update_item',
                                  result : 'json' }, product);
            getAjax(data,
                {
                    url: '/oa/'
                })
            .then(function (response) {
                self._changeBasketState(response);

                if(!_.isUndefined(response.data.item)){
                    basketRadio.trigger('changed:in:basket', { product_id: response.data.item.prod_id,
                                                               hash: response.data.item.hash,
                                                               count: response.data.item.count });

                    // Если товар успешно добавлен в корзину, то вызовем кастомное событие
                    self._triggerBodyEvent('tg-product-add');
                }
                if(!_.isUndefined(response.data.deleted)){
                    basketRadio.trigger('removed:from:basket', response.data.deleted);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
        _changeBasketState(response){
            let self = this;
            if(!_.isUndefined(response.data.count) && (!_.isUndefined(response.data.total)) && (response.data.href)){
                self.set({'count': response.data.count,
                          'total': response.data.total,
                          'href': response.data.href });
            }
        }
    }

    class Order extends Marionette.Application {
        onBeforeStart(app, options) {
            let self = this;
            self.model = new OrderState();
        }
        onStart(app, options) {
            let self = this;

            // Инициализируем блоки товаров на сайте
            let products = new Products();
            products.init({
                product: options.selectors.product,
                product_count: options.selectors.product_count,
                product_buy: options.selectors.product_buy
            });

            // Инициализируем блок корзины в шапке сайте
            new BasketBlock({
                el: options.selectors.basket,
                model: self.model
            });

            Basket({
                state: self.model
            });

            self.model.loadBasket();
        }
    }

    let order = new Order();
    order.start({
        selectors: {
            basket: opt.basket,
            product: opt.product,
            product_count: opt.product_count,
            product_buy: opt.product_buy
        }
    });
}

export {
    OrderInit
};

